function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import Button from "../Button";

const DebouncedButton = ({
  onClick,
  Component,
  delay = 650,
  ...props
}) => {
  const lastClickTime = /*#__PURE__*/React.createRef(Date.now());
  const clickHandler = React.useCallback((...args) => {
    if (!(lastClickTime.current && Math.abs(Date.now() - lastClickTime.current) < delay) && onClick) {
      lastClickTime.current = Date.now();
      return onClick(...args);
    }
  }, [delay, lastClickTime, onClick]);
  const ButtonComponent = Component || Button;
  return /*#__PURE__*/React.createElement(ButtonComponent, _extends({
    onClick: clickHandler
  }, props));
};

export default DebouncedButton;